import { request } from '@/http/http.js'

// privacy_policy内容 /api/index/privacy_policy
export function getPrivacy_policy(query) {
  return request({
    url: '/api/index/privacy_policy',
    method: 'get',
    params:query
  })
}
//  terms_conditions内容 /api/index/terms_conditions
export function getTerms_conditions(query) {
  return request({
    url: '/api/index/terms_conditions',
    method: 'get',
    params:query
  })
}
//  套餐获取 /api/index/packages
export function getPackages(query) {
  return request({
    url: '/api/index/packages',
    method: 'get',
    params:query
  })
}

export function getIspPackages(query) {
  return request({
    url: '/api/index/isp_package_list',
    method: 'get',
    params:query
  })
}

export function getPromotionConfig(query) {
  return request({
    url: '/api/index/promotion_config',
    method: 'get',
    params: query
  })
}

// 地区
export function getRegion(query) {
  return request({
    url: '/api/index/region',
    method: 'get',
    params:query
  })
}

export function getCountryList(query) {
  return request({
      url: '/api/index/country',
      method: 'get',
      params:query
  })
}

export function getProxyRegionList(query) {
  return request({
    url: '/api/index/proxy_region_list',
    method: 'get',
    params:query
  })
}

export function getProxyStateList(query) {
  return request({
      url: '/api/index/proxy_state_list',
      method: 'get',
      params:query
  })
}

export function getProxyDomainList(query) {
  return request({
      url: '/api/index/proxy_domain_list',
      method: 'get',
      params:query
  })
}

export function setLang(query) {
  return request({
      url: '/api/index/lang',
      method: 'post',
      params:query
  })
}
